import { number, object, string } from 'yup';

import {
  PayrollContributionAmountType,
  PayrollContributionPercentType,
  PayrollContributionRateType,
} from '../graphql/types';

function yupNumberTransform(_: string, value: string) {
  return !value || value === '.' ? 0 : Number(value.replaceAll(',', ''));
}

const contributionRateValidationSchema = object({
  text: string().when('type', {
    is: (type: PayrollContributionRateType) => type === 'PayrollContributionAmount',
    then: () => number().transform(yupNumberTransform),
    otherwise: () => number().transform(yupNumberTransform).max(100, 'Invalid percent value.'),
  }),
  type: string().oneOf([PayrollContributionPercentType, PayrollContributionAmountType]),
});

const legalAccountContributionRatesValidationSchema = object({
  traditional: contributionRateValidationSchema,
  roth: contributionRateValidationSchema,
}).test({
  message: 'Combined values cannot exceed 100%',
  test: values => {
    if (
      values.traditional.type !== 'PayrollContributionPercent' ||
      values.roth?.type !== 'PayrollContributionPercent'
    ) {
      return true;
    }
    return Number(values.traditional.text ?? 0) + Number(values.roth.text ?? 0) <= 100;
  },
});

export const formValidationSchema = object({
  base: legalAccountContributionRatesValidationSchema,
  bonus: legalAccountContributionRatesValidationSchema,
});
